/*
 * Mega menu: one open panel at a time
 * ---------------------------------------------------------------------------
 * theme.min.js opens a top-level panel on hover and on keyboard focus, and it
 * closes a hover-opened panel when the pointer moves to a sibling. It never
 * closes a focus-opened panel for the pointer, so Tab onto "Dildos & Anal",
 * then mouse over "Deals", and both panels are open at once: the hovered one
 * paints on top and the focused one's white background and "Shop all" row
 * poke out below it.
 *
 * This closes the odd one out. When the pointer enters a top-level item, any
 * other open item that still holds the keyboard focus is blurred and closed;
 * when the focus enters a top-level item, every other open item is closed.
 * Hover-only use is untouched: a panel opened by hover never holds the focus,
 * so the pointer path leaves it to the theme's own hover-intent timing.
 *
 * Closing mirrors what the theme's own deactivate does: drop
 * `is-dropdown-open` on the item, `aria-expanded="false"` on its link and
 * `aria-hidden="true"` on its panel.
 */
(function () {
  'use strict';

  var ROW = '.nav-bar__linklist';
  var ITEM = '.nav-bar__item';
  var LINK = ITEM + ' > [data-type="menuitem"]';
  var OPEN = 'is-dropdown-open';

  function holdsFocus(item) {
    var active = document.activeElement;
    return !!active && active !== document.body && item.contains(active);
  }

  function close(item) {
    if (holdsFocus(item)) document.activeElement.blur();
    item.classList.remove(OPEN);
    var link = item.querySelector('[data-type="menuitem"]');
    var panel = item.querySelector('[aria-hidden]');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function closeOthers(row, keep, onlyFocused) {
    var open = row.querySelectorAll(ITEM + '.' + OPEN);
    for (var i = 0; i < open.length; i++) {
      if (open[i] === keep) continue;
      if (onlyFocused && !holdsFocus(open[i])) continue;
      close(open[i]);
    }
  }

  function onEnter(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest(LINK);
    if (!link) return;
    var item = link.parentNode;
    var row = item.parentNode;
    if (!row || !row.matches || !row.matches(ROW)) return;
    closeOthers(row, item, event.type === 'mouseover');
  }

  function boot() {
    if (!document.querySelector(ROW)) return;
    document.addEventListener('mouseover', onEnter, true);
    document.addEventListener('focusin', onEnter, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
